<div class="gs-modal">
    <div class="gs-modal__content">
        <div class="text-center">
            <h3 class="mb-3">Are you sure you want to archive this story?</h3>
            <div (click)="cancel()" class="btn btn-gray-light mx-1">No, Cancel</div>
            <a href="javascript:void(0)" (click)="delete()" class="btn btn-pink mx-1">Yes, Archive</a>
        </div>
    </div>
</div>